import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import {
  Package,
  DollarSign,
  AlertTriangle,
  TrendingUp,
  ShoppingCart,
  Layers,
} from 'lucide-react';
import { InventoryStats as IInventoryStats } from '../../types/inventory';

interface InventoryStatsProps {
  stats: IInventoryStats;
}

const InventoryStats: React.FC<InventoryStatsProps> = ({ stats }) => {
  const { t } = useLanguage();

  const statCards = [
    {
      title: t('inventory.stats.totalItems'),
      value: stats.total_items.toLocaleString(),
      icon: Package,
      color: 'bg-blue-500',
      lightColor: 'bg-blue-100',
      textColor: 'text-blue-600',
    },
    {
      title: t('inventory.stats.totalValue'),
      value: `$${stats.total_value.toLocaleString()}`,
      icon: DollarSign,
      color: 'bg-green-500',
      lightColor: 'bg-green-100',
      textColor: 'text-green-600',
    },
    {
      title: t('inventory.stats.lowStock'),
      value: stats.low_stock_items.toLocaleString(),
      icon: AlertTriangle,
      color: 'bg-orange-500',
      lightColor: 'bg-orange-100',
      textColor: 'text-orange-600',
    },
    {
      title: t('inventory.stats.outOfStock'),
      value: stats.out_of_stock_items.toLocaleString(),
      icon: TrendingUp,
      color: 'bg-red-500',
      lightColor: 'bg-red-100',
      textColor: 'text-red-600',
    },
    {
      title: t('inventory.stats.categories'),
      value: stats.categories_count.toLocaleString(),
      icon: Layers,
      color: 'bg-purple-500',
      lightColor: 'bg-purple-100',
      textColor: 'text-purple-600',
    },
    {
      title: t('inventory.stats.recentTransactions'),
      value: stats.recent_transactions.toLocaleString(),
      icon: ShoppingCart,
      color: 'bg-indigo-500',
      lightColor: 'bg-indigo-100',
      textColor: 'text-indigo-600',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-8">
      {statCards.map((stat, index) => (
        <div key={index} className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between mb-4">
            <div className={`p-3 rounded-lg ${stat.lightColor}`}>
              <stat.icon className={`w-6 h-6 ${stat.textColor}`} />
            </div>
          </div>
          <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
          <p className="text-sm text-gray-600 mt-1">{stat.title}</p>
        </div>
      ))}
    </div>
  );
};

export default InventoryStats;